import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { registrationSlugs } from '../../shared/data/registrationSlugs';

const RecertificateRoute = ({ component: Component, needsRecertification, ...rest }: any) => {
  const routeComponent = (props: any) =>
    needsRecertification ? (
      <Redirect to={{ pathname: `/recertification/${registrationSlugs[0]}`, state: { from: props.location } }} />
    ) : (
      <Component {...props} />
    );

  return <Route {...rest} render={routeComponent} />;
};

export default RecertificateRoute;
